import {
  Card,
  CardContent,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@bpinternal/ui-kit-next'
import { useState, type FC } from 'react'
import {
  addDailyAverage,
  addProjectedCumulative,
  collapseDailyUsageToTopN,
  DailySummary,
  FlattenedDailySummary,
} from '../utils'
import { DailySpendChart } from './DailySpendChart'
import { DailySpendChartHeader, SpendType } from './DailySpendChartHeader'

type Props = {
  dataPerSource: Record<string, any>[]
  selectedMonth: Date
  sortedData: DailySummary[]
}

export const BotDailyAiSpend: FC<Props> = ({ dataPerSource, selectedMonth, sortedData }) => {
  const [activeChart, setActiveChart] = useState<SpendType>('total')

  const totalAiSpend = sortedData?.reduce((acc, { value }) => acc + value, 0) ?? 0
  const averageAiSpendPerDay = totalAiSpend ? totalAiSpend / (sortedData?.length ?? 1) : 0

  const { grouped: collapsedDataSource, visibleKeys: sourceKeys } = collapseDailyUsageToTopN(dataPerSource, 5, 0.01)
  const sourceDataWithProjection = addDailyAverage(collapsedDataSource, selectedMonth, averageAiSpendPerDay)
  const sourceDataWithProjectedCumulative: FlattenedDailySummary[] = addProjectedCumulative(
    sortedData,
    sourceDataWithProjection,
    averageAiSpendPerDay
  )

  return (
    <Card className="h-full">
      <DailySpendChartHeader
        totalAiSpend={totalAiSpend}
        averageAiSpendPerDay={averageAiSpendPerDay}
        onActiveChartChange={(type) => setActiveChart(type)}
        title="AI Spend by Source"
        description="Track the AI spend for this bot, with a breakdown by source. Gain insights into which integrations are driving your costs."
      />
      <CardContent className="flex flex-col gap-6 p-2 sm:p-6">
        <DailySpendChart
          data={sourceDataWithProjectedCumulative}
          selectedMonth={selectedMonth}
          activeChart={activeChart}
          visibleKeys={sourceKeys}
        />
      </CardContent>
    </Card>
  )
}
